'use strict';

/**
 *
 * @name: imageSlider
 *
 */

import DirectiveTemplate from './nn-image-slider.directive.html';
import './nn-image-slider.directive.scss';

function NnImageSliderDirective(
  $sce,
  $rootScope,
  nnModalsService
) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      images: '&'
    },
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      $rootScope.slideshow = {};
      $rootScope.slideshow.activeIndex = 0;
      $rootScope.slideshow.labelIndex = 1;
      $rootScope.slideshow.images = _getImages();
      $rootScope.slideshow.prevImageDisabled = ($rootScope.slideshow.activeIndex === 0);
      $rootScope.slideshow.nextImageDisabled = (($rootScope.slideshow.activeIndex + 1) === $rootScope.slideshow.images.length);

      /**
       *
       * @PUBLIC_METHODS
       *
       * This logic is shared with nn-slideshow-modal
       *
       */

      $rootScope.slideshow.showImage = function({ index }) {

        $rootScope.slideshow.activeIndex = index;
        $rootScope.slideshow.labelIndex = index + 1;
        $rootScope.slideshow.prevImageDisabled = (index === 0);
        $rootScope.slideshow.nextImageDisabled = ((index + 1) === $rootScope.slideshow.images.length);
      };

      $rootScope.slideshow.showModal = function() {
        nnModalsService.showModal('slideshow')
      };

      $rootScope.slideshow.nextImage = function() {

        $rootScope.slideshow.showImage({ index: $rootScope.slideshow.activeIndex + 1 })
      };

      $rootScope.slideshow.prevImage = function() {

        $rootScope.slideshow.showImage({ index: $rootScope.slideshow.activeIndex - 1 })
      };

      /**
       *
       * @PRIVATE_METHODS
       *
       */

      function _getImages() {
        return (scope.images() || []).map(function(item) {

          item.imageSrc = $sce.trustAsResourceUrl(item.content);
          return item;
        });
      }

      function _checkIfImgLoaded() {

        var a, imgElm;
        var myInterval = setInterval(function() {

          imgElm = element.find('.images .img img');
          a = imgElm.height();

          if (a) {

            var imgLoadedEvent;

            try {

              imgLoadedEvent = new Event('imgLoaded');
            } catch (e) {

              imgLoadedEvent = document.createEvent('Event');
              imgLoadedEvent.initEvent('imgLoaded', true, true);
            }

            document.dispatchEvent(imgLoadedEvent);
            clearInterval(myInterval);
          }
        }, 100);
      }

      function _bindEvents() {

        $(window).on('keyup', _onKeyUp);
      }

      function _unbindEvents() {

        $(window).off('keyup', _onKeyUp);
      }

      function _onKeyUp(event) {

        var key = (event.charCode || event.keyCode || 0);

        switch (key) {

          case 37:

            $rootScope.slideshow.prevImage();
            break;

          case 39:

            $rootScope.slideshow.nextImage();
            break;
        }
      }

      /**
       *
       * @INIT
       *
       */

      _checkIfImgLoaded();
      _bindEvents();

      scope.$on('destroy', function() {

        _unbindEvents();
        delete $rootScope.slideshow;
      });
    }
  };
}

export default NnImageSliderDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-image-slider/nn-image-slider.directive.js